import React, { useContext } from 'react';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import IContract from 'src/models/contract_types/IContract';
import Ownership from 'src/models/tract_detail/Ownership';
import ContractGenerationOwnerData from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationOwnerData';
import { AnyObject } from 'final-form';

interface IConfirmDecommitContractDialogProps {
    entityName: string;
    ownerData: LeaseGenerationOwnerData | ContractGenerationOwnerData;
    contractData: IContract;
    commitListener: (data: boolean) => void;
    confirmDecommit: () => void;
    cancelDecommit: () => void;
}

const ConfirmDecommitContractDialog = (props: IConfirmDecommitContractDialogProps) => {
    const { response, post} = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const updateOwnerData = () => {
        let newOwnerObj: AnyObject = props?.ownerData ? props?.ownerData : null;
        let ownerships = 'ownerships';
        let leaseOwnershipList = props?.contractData?.tracts?.filter(t => t.includeTract === true);

        for (let leaseOwnership of leaseOwnershipList) {
            let updateOwnershipId = newOwnerObj[ownerships].findIndex((o: AnyObject) => o.id === leaseOwnership.ownershipId);
            let tractIndex = newOwnerObj.tracts.findIndex((t: AnyObject) => t.ownershipId === leaseOwnership.ownershipId);

            let sectionNumber: number = newOwnerObj.tracts[tractIndex].sectionNumber;

            let updateOwnership: Ownership = {
                id: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].id : null,
                ownerLookUpId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownerLookUpId : null,
                horizonId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].horizonId : null,
                ownershipType: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownershipType : '',
                decimalInterest: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].decimalInterest : null,
                executiveRights: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].executiveRights : null,
                isLeased: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isLeased : false,
                parentOwnershipId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].parentOwnershipId : null,
                leaseBuyer: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leaseBuyer : '',
                contactCategory: null,
                ownershipContactCategoryId: null,
                leasedStatus: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leasedStatus : '',
                additionalOwnershipTypeId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnershipTypeId : null,
                additionalOwnerships: props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnerships : [],
                note: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].note : '',
                isWIClientAcreage: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isWIClientAcreage : null,
            };

            updateOwnershipDetail(updateOwnership, sectionNumber);
        }
        if (leaseOwnershipList.length === 0 && ownerships?.length > 0) {
            const updateOwnershipId = 0;
            const updateOwnership: Ownership = {
                id: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].id : null,
                ownerLookUpId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownerLookUpId : null,
                horizonId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].horizonId : null,
                ownershipType: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownershipType : '',
                decimalInterest: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].decimalInterest : null,
                executiveRights: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].executiveRights : null,
                isLeased: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isLeased : false,
                parentOwnershipId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].parentOwnershipId : null,
                leaseBuyer: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leaseBuyer : '',
                contactCategory: null,
                ownershipContactCategoryId: null,
                leasedStatus: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leasedStatus : '',
                additionalOwnershipTypeId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnershipTypeId : null,
                additionalOwnerships: props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnerships : [],
                note: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].note : '',
                isWIClientAcreage: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isWIClientAcreage : null,
            };
            updateOwnershipDetail(updateOwnership, 0);
        }
    };

    const updateOwnershipDetail = async (ownershipDetail: Ownership, sectionNumber: number) => {
        let result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/fields/${sectionNumber}/tracts/save-ownership-detail`,
            ownershipDetail
        );

        if (response.ok) {
            console.log('Successfully update the contact category!!', result);
            props.confirmDecommit();
        } else {
            console.log('Error while trying to update the contact categroy of the owner!!');
        }
    };

    return (
        <Dialog title="Confirm Uncommit">
            <div style={{ textAlign: 'center', fontSize: '2rem' }} className="mb-2">
                Are you sure want to uncommit contract {props.entityName}?
            </div>
            <div style={{ textAlign: 'center' }}>
                <Button text="Confirm" onClick={updateOwnerData} className="mr-2" intent="primary" />
                <Button text="Cancel" onClick={props.cancelDecommit} intent="danger" />
            </div>
        </Dialog>
    );
};

export default ConfirmDecommitContractDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/ConfirmDecommitContractDialog.tsx